import { combineReducers } from 'redux';
import authReducer from './authReducer';
import benefitsReducer from './benefitsReducer';
import personalInfoReducer from './personalInfoReducer';
import notificationsReducer from './notificationsReducer';
import paymentsReducer from './paymentsReducer';
import configReducer from './configReducer';
import companiesReducer from './companiesReducer';
import employeesReducer from './employeesReducer';

const reducers = combineReducers({
  auth: authReducer,
  benefits: benefitsReducer,
  personalInfo: personalInfoReducer,
  notifications: notificationsReducer,
  payments: paymentsReducer,
  config: configReducer,
  companies: companiesReducer,
  employees: employeesReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
